module.exports = __webpack_public_path__ + "static/img/photo.fcc304f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo.jpg
// module id = Jks+
// module chunks = 1